import React, { PureComponent } from 'react';

interface IProps {
  code: any;
  chatType: any;
}

export default class Chatroll extends PureComponent<IProps> {
  render() {
    if (parseInt(this.props.chatType) === 1)
      return (
        <iframe
          title="chatroll"
          width="100%"
          height="350"
          frameBorder="0"
          scrolling="no"
          // marginHeight='0'
          // marginwidth='0'
          // allowtransparency='true'
          src={`https://chatroll-cloud-1.com/embed/chat/aula-ao-vivo?id=${this.props.code}&platform=html`}
        ></iframe>
      );

    return (
      <iframe
        title="chatroll"
        width="100%"
        height="350"
        frameBorder="0"
        scrolling="no"
        // marginheight="0"
        // marginwidth="0"
        // allowtransparency="true"
        src={`https://chatroll.com/embed/chat/?id=${this.props.code}&platform=html`}
      ></iframe>
    );
  }
}
